import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-polizas-agregar',
  templateUrl: './polizas-agregar.component.html',
  styleUrls: ['./polizas-agregar.component.scss']
})
export class PolizasAgregarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/polizas/polizas-agregar/polizas-agregar.component.ts